import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Shuffle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.4697 3.03039L12.1893 3.75006H10.23C9.86506 3.75006 9.51837 3.90951 9.2809 4.18657L7 6.84761L4.7191 4.18657C4.48162 3.90951 4.13494 3.75006 3.77003 3.75006H1V5.25006H3.65505L6.01219 8.00006L3.65505 10.7501H1V12.2501H3.77003C4.13494 12.2501 4.48162 12.0906 4.7191 11.8135L7 9.1525L9.2809 11.8135C9.51837 12.0906 9.86506 12.2501 10.23 12.2501H12.1893L11.4697 12.9697L12.5303 14.0304L15.0607 11.5001L12.5303 8.96973L11.4697 10.0304L12.1893 10.7501H10.345L7.98781 8.00006L10.345 5.25006H12.1893L11.4697 5.96973L12.5303 7.03039L15.0607 4.50006L12.5303 1.96973L11.4697 3.03039Z"
      fill="currentColor"
    />
  </Icon>
));

export default Shuffle;
